<template>
	<section class="small-12 flex vertical-align unitInfo" v-if="unit">
		<div class="small-12 columns listingsTitle flex justify-center">
            <h3 class="small-12 flex vertical-align">
                Unit Listing Details
            </h3>
        </div>
		<div class="small-12 large-6 unitPhotos" v-if="unit.links.media.length > 0">
			<div class="small-12 columns primaryPhoto" @mouseover="display_fullscreen = true" @mouseleave="display_fullscreen = false">
				<div class="small-12 container borderRadius8">
					<picture class="small-12 flex borderRadius8" :style="primary_image_bg_style"></picture>
					<figure class="small-12 animated fadeIn flex justify-center vertical-align" v-show="display_fullscreen" @click="openFullscreenModal()">
						<i class="material-icons-outlined">fullscreen</i>
					</figure>
				</div>
			</div>
			<ul class="small-12 flex secondaryPhotos float-left">
				<li class="small-12 large-4 columns" v-if="unit.links.media.length > 0">
					<picture class="small-12 flex borderRadius4" :style="image_2_bg_style" @click="viewThumbnail(0)"></picture>
				</li>
				<li class="small-12 large-4 columns" v-if="unit.links.media.length > 1" @click="viewThumbnail(1)">
					<picture class="small-12 flex borderRadius4" :style="image_3_bg_style"></picture>
				</li>
				<li class="small-12 large-4 columns" v-if="unit.links.media.length > 2" @click="viewThumbnail(2)">
					<picture class="small-12 flex borderRadius4" :style="image_4_bg_style"></picture>
				</li>
			</ul>
		</div>
		<div class="small-12 large-6 unitPhotos" v-else>
			<picture class="small-12 flex justify-center vertical-align" style="height:100%;">
				<img width="300" :src="empty_unit_image" alt="Empty Unit Photos">
			</picture>
		</div>
		<div class="small-12 large-6 columns unitDetails">
			<div class="small-12 rent">
				<h2 v-if="rent">${{rent.attributes.amount | convertCentsToDollars }}/mo.</h2>
				<h2 v-else>$0.00/mo.</h2>
			</div>
			<div class="small-12 address">
				<p>{{ unit.attributes.address.street_1 }} {{ unit.attributes.address.city }}, {{ unit.attributes.address.state }} {{ unit.attributes.address.zip_code }}</p>
			</div>
			<div class="small-12 specs">
				<ul class="small-12 flex float-left">
					<li class="small-12 large-4">
						<span class="float-left small-12">Bedrooms</span>
						<p class="small-12 flex vertical-align" v-if="unit.attributes.bedrooms">
							{{ unit.attributes.bedrooms }} 
							<i class="material-icons-outlined">king_bed</i>
						</p>
						<p class="small-12 flex vertical-align" v-else>
							0
							<i class="material-icons-outlined">king_bed</i>
						</p>
					</li>
					<li class="small-12 large-4">
						<span class="float-left small-12">Bathrooms</span>
						<p class="small-12 flex vertical-align" v-if="unit.attributes.bathrooms">
							{{ unit.attributes.bathrooms }} 
							<i class="material-icons-outlined">bathtub</i>
						</p>
						<p class="small-12 flex vertical-align" v-else>
							0 
							<i class="material-icons-outlined">bathtub</i>
						</p>
					</li>
					<li class="small-12 large-4">
						<span class="float-left small-12">Area</span>
						<p class="small-12 flex" v-if="unit.attributes.square_feet">
							{{ unit.attributes.square_feet }} 
							<i class="ft2">ft.2</i>
						</p>
						<p class="small-12 flex" v-else>
							0 
							<i class="ft2">ft.2</i>
						</p>
					</li>
				</ul>
			</div>
			<div class="small-12 title">
				<h6>Description</h6>
			</div>
			<div class="small-12 description">
				<p v-if="unit.attributes.description">
					{{ unit.attributes.description }}
				</p>
				<p v-else>
					No description for your unit can be found.
				</p>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'

	// Import the events
	import { GetRent } from '@/events/rent/GetRent'
	import { GetLease } from '@/events/leases/GetLease'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitDetails',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			MoneyConversions,
			GetRent,
			GetLease

		],

		/*
		**  Set the props
		*/

		props: {

			unit: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			empty_unit_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fhouse-images.svg?alt=media&token=bb8012e9-2256-4801-b184-a1cd7bb8adbe',
			primary_image: null,
			open_fullscreen_modal: false,
			display_fullscreen: false,

		}),

		/*
		**  Watch em'
		*/

		watch: {

			unit: {

				immediate: true, // Load on created
				handler(unit) {

					/*
					**	Set the primary image
					**	@method: @here
					*/

					if (unit) this.setPrimaryImage();

					/*
					**	Get the lease
					**	@method: Events/Leases/GetLease
					*/

					if (unit) this.getLeaseHandler(this.$route.params.id, unit.relationships.lease);

				}

			},

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					**	Get the rent
					**	@method: Events/Rent/GetRent
					*/

					if (lease) this.getRentHandler(lease.relationships.active_rent);

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			setPrimaryImage: function() {

				try {

					/*
					**	Set the prop
					**	@location: @here
					*/

					this.primary_image = this.unit.links.media[0];

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to set the primary image.',
						errorType: 'Firestore Database',
						section: 'Unit Details',
						uid: 'nTt8X42OJshaWeeJteBC',
						error: e
					});

				}

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			primary_image_bg_style: function() {

				return 'background:url(' + this.primary_image + ') no-repeat center/cover;';

			},

			image_2_bg_style: function() {

				return 'background:url(' + this.unit.links.media[0] + ') no-repeat center/cover;';

			},

			image_3_bg_style: function() {

				return 'background:url(' + this.unit.links.media[1] + ') no-repeat center/cover;';

			},

			image_4_bg_style: function() {

				return 'background:url(' + this.unit.links.media[2] + ') no-repeat center/cover;';

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>